var _rect, _path, _path2, _path3, _path4, _path5, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglepay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.558 15.528v-2.934h1.515c.62 0 1.144-.208 1.571-.618l.103-.104c.78-.85.728-2.173-.103-2.958a2.162 2.162 0 0 0-1.571-.63H15.64v7.244h.917zm0-3.824v-2.53h1.538c.33 0 .643.127.877.358.495.485.507 1.294.028 1.796a1.19 1.19 0 0 1-.905.376h-1.538zm7.465-.745c-.393-.364-.928-.549-1.606-.549-.871 0-1.526.323-1.959.965l.809.514c.296-.44.7-.659 1.213-.659.324 0 .637.122.882.341.24.208.376.508.376.826v.214c-.353-.196-.797-.3-1.344-.3-.637 0-1.15.15-1.531.456-.382.306-.575.71-.575 1.225-.012.468.187.912.54 1.213.36.323.815.485 1.35.485.632 0 1.133-.283 1.515-.85h.04v.688h.876v-3.056c0-.64-.193-1.15-.586-1.513zm-2.488 3.657a.753.753 0 0 1-.302-.607c0-.271.125-.497.37-.676.25-.179.564-.271.934-.271.512-.006.911.11 1.196.34 0 .393-.154.734-.456 1.023a1.446 1.446 0 0 1-1.03.433 1.11 1.11 0 0 1-.712-.242zm5.044 3.09l3.064-7.134h-.997L27.23 14.13h-.017l-1.453-3.558h-.996l2.01 4.639-1.139 2.495h.945z",
    fill: "#3C4043"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.393 11.958c0-.283-.023-.566-.069-.843H9.458v1.6h2.215a1.928 1.928 0 0 1-.82 1.265v1.04h1.321c.774-.722 1.219-1.79 1.219-3.062z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.458 16.025c1.105 0 2.039-.37 2.716-1.005l-1.32-1.04c-.37.254-.843.399-1.396.399-1.07 0-1.976-.734-2.3-1.716H5.797v1.075a4.09 4.09 0 0 0 3.661 2.287z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.158 12.663a2.544 2.544 0 0 1 0-1.595V10H5.797a4.177 4.177 0 0 0 0 3.731l1.361-1.068z",
    fill: "#FBBC04"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.458 9.353a2.189 2.189 0 0 1 1.572.624l1.173-1.19a3.926 3.926 0 0 0-2.745-1.08c-1.549 0-2.966.889-3.661 2.293l1.36 1.074c.325-.988 1.23-1.721 2.301-1.721z",
    fill: "#EA4335"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    stroke: "#F5F5FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglepay);
export default __webpack_public_path__ + "static/media/googlepay.93dd6bbf3684a7510567b9c35055421c.svg";
export { ForwardRef as ReactComponent };